
import { defineComponent } from 'vue';
import { useStore } from 'vuex';
import { Button } from 'ant-design-vue';
// import { useRouter } from 'vue-router';

export default defineComponent({
  components: {
    aButton: Button,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    back: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    // const router = useRouter();
    const store = useStore();
    const goBack = () => {
      // context.emit('change-component', '');
      store.commit('exhibition/upCurrent', 'list');
    };
    return {
      goBack,
    };
  },
});
